import { Dispatch } from 'redux';
import { typedAction } from 'store/modules/base';
import {
  DELETEUploadDoc as DELETEUploadDocParticipante,
  GETDocumentDownloadUrl as GETDocumentoDownloadUrlParticipante,
  GETHasCnpj,
  GETParticipante,
  GETParticipantes,
  POSTLiberarParticipante,
  POSTParticipante,
  POSTSuspenderParticipante,
  POSTValidateParticipante,
  PUTParticipante,
  PUTUploadDoc as PUTUploadDocParticipante,
  GETHistoricoParticipante,
  GETParticipantesPaginated,
  POSTParticipantesPaginated,
  GETParticipantesSolicitadosPeloUsuario,
  GETParticipantesResume,
} from 'requests/participante';
import {
  CadastroParticipanteRequest,
  ParticipanteResponse,
  ParticipanteDocumentResponse,
  GETParticipanteFilterParams,
  RegistroStatus,
  HistoricoResponse,
  PaginatedResult,
  POSTParticipanteFilterParams,
} from 'common/genericTypes';

export interface ParticipanteApiState {
  postParticipante(
    dispatch: Dispatch,
    participante: CadastroParticipanteRequest,
    stackRequest?: boolean
  ): Promise<ParticipanteResponse>;
  putParticipante(
    dispatch: Dispatch,
    participanteId: string,
    participante: CadastroParticipanteRequest,
    stackRequest?: boolean
  ): Promise<ParticipanteResponse>;
  putUploadDoc(
    dispatch: Dispatch,
    participanteId: string,
    participanteDocumentType: string,
    file: File,
    dataVencimento?: string,
    stackRequest?: boolean,
  ): Promise<ParticipanteDocumentResponse>;
  getParticipante(dispatch: Dispatch, participanteId: string, stackRequest?: boolean): Promise<ParticipanteResponse>;
  getParticipantesPaginated(
    dispatch: Dispatch,
    params?: GETParticipanteFilterParams,
    stackRequest?: boolean
  ): Promise<PaginatedResult<ParticipanteResponse>>;
  postParticipantePaginated(
    dispatch: Dispatch,
    filter?: POSTParticipanteFilterParams,
    stackRequest?: boolean
  ): Promise<PaginatedResult<ParticipanteResponse>>;
  getParticipantes(
    dispatch: Dispatch,
    params?: GETParticipanteFilterParams,
    stackRequest?: boolean
  ): Promise<Array<ParticipanteResponse>>;
  getParticipantesResume(
    dispatch: Dispatch,
    params?: GETParticipanteFilterParams,
    stackRequest?: boolean
  ): Promise<Array<ParticipanteResponse>>;
  getHasCnpj(dispatch: Dispatch, cnpj: string, stackRequest?: boolean): Promise<boolean>;
  postValidateParticipante(
    dispatch: Dispatch,
    status: RegistroStatus,
    participanteId: string,
    justificativa?: string,
    attachments?: File[],
    stackRequest?: boolean
  ): Promise<any>;
  getDocumentDownloadUrl(
    dispatch: Dispatch,
    participanteId: string,
    documentId: string,
    stackRequest?: boolean
  ): Promise<string>;
  deleteUploadDoc(dispatch: Dispatch, participanteId: string, documentId: string, stackRequest?: boolean): Promise<any>;
  postSuspenderParticipante(
    dispatch: Dispatch,
    participanteId: string,
    justificativa: string,
    anexosList: File[],
    stackRequest?: boolean
  ): Promise<ParticipanteResponse>;
  postLiberarParticipante(
    dispatch: Dispatch,
    participanteId: string,
    justificativa: string,
    anexosList: File[],
    stackRequest?: boolean
  ): Promise<ParticipanteResponse>;
  getHistoricoParticipante(
    dispatch: Dispatch,
    participanteId: string,
    stackRequest?: boolean
  ): Promise<Array<HistoricoResponse>>;
  getParticipantesSolicitadosPeloUsuario(
    dispatch: Dispatch,
    stackRequest?: boolean
  ): Promise<Array<ParticipanteResponse>>;
}

const participanteApiInitialState: ParticipanteApiState = {
  postParticipante: POSTParticipante,
  putParticipante: PUTParticipante,
  putUploadDoc: PUTUploadDocParticipante,
  getParticipante: GETParticipante,
  getParticipantes: GETParticipantes,
  getParticipantesResume: GETParticipantesResume,
  getHasCnpj: GETHasCnpj,
  postValidateParticipante: POSTValidateParticipante,
  getDocumentDownloadUrl: GETDocumentoDownloadUrlParticipante,
  deleteUploadDoc: DELETEUploadDocParticipante,
  postSuspenderParticipante: POSTSuspenderParticipante,
  postLiberarParticipante: POSTLiberarParticipante,
  getHistoricoParticipante: GETHistoricoParticipante,
  getParticipantesPaginated: GETParticipantesPaginated,
  postParticipantePaginated: POSTParticipantesPaginated,
  getParticipantesSolicitadosPeloUsuario: GETParticipantesSolicitadosPeloUsuario,
};

enum ParticipanteApiActionType {
  Update = 'participanteApi/UPDATE',
  Reset = 'participanteApi/RESET',
}

export const updateParticipanteApi = (state: ParticipanteApiState) => {
  return typedAction(ParticipanteApiActionType.Update, state);
};

export const resetParticipanteApi = () => {
  return typedAction(ParticipanteApiActionType.Reset);
};

type ParticipanteApiAction = ReturnType<typeof updateParticipanteApi | typeof resetParticipanteApi>;

export function participanteApiReducer(
  state: ParticipanteApiState = participanteApiInitialState,
  action: ParticipanteApiAction
): ParticipanteApiState {
  switch (action.type) {
    case ParticipanteApiActionType.Update:
      return { ...action.payload };
    case ParticipanteApiActionType.Reset:
      return { ...participanteApiInitialState };
    default:
      return state;
  }
}
